import { render, staticRenderFns } from "./DeviceSetupSplash.vue?vue&type=template&id=72ce5d5b&scoped=true"
import script from "./DeviceSetupSplash.vue?vue&type=script&lang=js"
export * from "./DeviceSetupSplash.vue?vue&type=script&lang=js"
import style0 from "./DeviceSetupSplash.vue?vue&type=style&index=0&id=72ce5d5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ce5d5b",
  null
  
)

export default component.exports